<template>
  <div>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="12">
        <label>{{ participante.user.name }} </label> - <label class="text-danger">{{ participante.user.email }}</label>
      </SGPColComponent>
    </SGPRowComponent>
    <hr>
  </div>
</template>

<script>

export default {
  name: "EquipeParticipantesComponent",

  props: {
    participante: {
      type: Object,
      required: false
    }
  },
}
</script>